import '../assets/scss/main.scss';
import { initFacts } from './modules/facts';
import { initScrollAnimations } from './modules/scroll-animations';

document.addEventListener('DOMContentLoaded', () => {
    initFacts();
    initScrollAnimations();
});
